import { useContext } from 'react';
import axios from '../_actions/axiosInstance';
import { SidebarContext } from '../layout/sidebarContext';

const usePageContext = () => {
  const [state, setState] = useContext(SidebarContext);

  function setIsOpen(val) {
    setState({ ...state, isOpen: val });
  }

  function getPinState() {
    return state.isPinned;
  }

  function checkPinned() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.logged_in) {
      setState({ ...state, isPinned: user.pinned_sidebar });
    }
  }

  async function togglePin() {
    const newPinned = !getPinState();
    setState({ ...state, isPinned: newPinned });
    try {
      await axios.patch('/api/v2/users/me', { pinned_sidebar: newPinned });
      setState({ ...state, isPinned: newPinned });
      const user = JSON.parse(localStorage.getItem('user'));
      user.pinned_sidebar = newPinned;
      localStorage.setItem('user', JSON.stringify(user));
    } catch (error) {
      console.error(error);
    }
  }
 function iconOnClick(val) {
  setIsOpen(val);
 }
  return {
    ...state,
    setIsOpen,
    togglePin,
    getPinState,
    checkPinned,
    iconOnClick,
  };
};

export default usePageContext;
